"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("../button");
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _TableFilter = _interopRequireDefault(require("./TableFilter.style"));
var _index = _interopRequireDefault(require("../collapse/FilterCollapse/index"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TableFilter = function TableFilter(_ref) {
  var title = _ref.title,
    filterButtonText = _ref.filterButtonText,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    list = _ref.list,
    selected = _ref.selected,
    hasChanges = _ref.hasChanges,
    disabled = _ref.disabled,
    isExpanded = _ref.isExpanded,
    onExpandToggle = _ref.onExpandToggle,
    virtualized = _ref.virtualized;
  var expandTriggerProps = {};
  if (!disabled) {
    expandTriggerProps = {
      onClick: function onClick() {
        return onExpandToggle(!isExpanded);
      },
      onKeyDown: function onKeyDown() {
        return onExpandToggle(!isExpanded);
      },
      role: 'button',
      tabIndex: '0'
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_TableFilter["default"], {
    className: "filter-wrapper",
    isExpanded: isExpanded && !disabled,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-header"
  }, isExpanded && !disabled && /*#__PURE__*/_react["default"].createElement("span", {
    className: "filter-title"
  }, title), /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    className: "filter-icon",
    icon: "ion-android-funnel"
  }, expandTriggerProps, {
    "aria-label": "Toggle filters"
  }))), isExpanded && !disabled && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-content"
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    items: list,
    selectedItems: selected,
    onChange: onChange,
    virtualized: virtualized
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-footer"
  }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
    medium: true,
    fullWidth: true,
    action: function action() {
      onSubmit();
    },
    id: "applyFilters",
    disabled: !hasChanges
  }, filterButtonText))));
};
TableFilter.defaultProps = {
  disabled: false,
  hasChanges: true,
  selected: {},
  virtualized: false
};
TableFilter.propTypes = {
  /** The title of the filter */
  title: _propTypes["default"].string.isRequired,
  /** The title of the filter */
  disabled: _propTypes["default"].bool,
  /** Callback for when clicking a new filter */
  onChange: _propTypes["default"].func.isRequired,
  /** Callback for when applying the filters */
  onSubmit: _propTypes["default"].func.isRequired,
  /** Flag to indicate when the filter should be exanded */
  isExpanded: _propTypes["default"].bool.isRequired,
  /** Callback for when clicking on the expand button */
  onExpandToggle: _propTypes["default"].func.isRequired,
  /** Filter options */
  list: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      count: _propTypes["default"].number,
      value: _propTypes["default"].string
    }))
  })).isRequired,
  /** Selected filter options */
  selected: _propTypes["default"].shape({}),
  /** Flag to indicate if there are changes in the filters */
  hasChanges: _propTypes["default"].bool,
  /** Filter button string */
  filterButtonText: _propTypes["default"].string.isRequired,
  /** Flag to indicate if list should be virtualized */
  virtualized: _propTypes["default"].bool
};
TableFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableFilter",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "The title of the filter",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hasChanges": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Flag to indicate if there are changes in the filters",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "selected": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Selected filter options",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "virtualized": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if list should be virtualized",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "title": {
      "description": "The title of the filter",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "Callback for when clicking a new filter",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onSubmit": {
      "description": "Callback for when applying the filters",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "isExpanded": {
      "description": "Flag to indicate when the filter should be exanded",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "onExpandToggle": {
      "description": "Callback for when clicking on the expand button",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "list": {
      "description": "Filter options",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "key": {
              "name": "string",
              "required": true
            },
            "title": {
              "name": "string",
              "required": true
            },
            "options": {
              "name": "arrayOf",
              "value": {
                "name": "shape",
                "value": {
                  "count": {
                    "name": "number",
                    "required": false
                  },
                  "value": {
                    "name": "string",
                    "required": false
                  }
                }
              },
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "filterButtonText": {
      "description": "Filter button string",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = TableFilter;
exports["default"] = _default;